/**
@format
@flow
*/
import React from 'react';
import { ImageOverlay as KrispyOverlay } from '@krispy/media/web';
import Colors from '@ziynx/theme/colors';

type Props = $ReadOnly<{|
  icon?: {
    color?: string,
    /**
    * Name of the icon.
    */
    name?: string,
    /**
    * Position of the icon.
    */
    position?: 'bottomRight' | 'center',
    padding?: string,
  },
  /**
  * Provides source of image.
  */
  imageSource?: string,
  /**
    * Function to be fired when icon is pressd.
    */
  onPress?: () => void,
|}>;

const ImageOverlay = (props: Props): React$Node => {
  const {
    icon,
    imageSource,
    onPress,
    ...rest
  } = props;

  return (
    <KrispyOverlay
      imageSource={imageSource}
      icon={icon}
      onPress={onPress}
      {...rest}
    />
  );
};

ImageOverlay.defaultProps = {
  icon: {
    color: Colors.White,
    position: 'bottomRight',
    name: undefined,
    padding: '16px',
  },
};

export default ImageOverlay;
